import { uniqueId } from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { addOverlay, removeOverlay } from '../../Actions/Overlay.action';
import clsx from 'clsx';
import { translate } from '../../Services/translation';
import Icon from '../Icon';

interface MegaMenuWrapperProps {
  wrapperOpen: boolean;
}

const MegaMenu = ({
  open,
  onMegaMenuClose,
  onMouseOverMegaMenu,
  onMouseLeaveMegaMenu,
  link,
  blocks,
}) => {
  const dispatch = useDispatch();
  const blockContainerRef = useRef<HTMLDivElement>(null);
  const [id] = useState(uniqueId());

  useEffect(() => {
    if (!blockContainerRef?.current) return;
    blockContainerRef.current.innerHTML = '';
    for (let block of blocks) {
      blockContainerRef.current.appendChild(block);
    }
  }, [blockContainerRef, blocks]);

  useEffect(() => {
    if (open) {
      dispatch(addOverlay('MegaMenu-' + id, onMegaMenuClose));
    } else {
      dispatch(removeOverlay('MegaMenu-' + id));
    }
  }, [open]);

  return (
    <div
      className={clsx(
        'absolute',
        'top-full',
        'left-0',
        'right-0',
        'py-6',
        open ? 'opacity-1' : 'opacity-0',
        !open && 'pointer-events-none',
        'bg-white',
        'transition-opacity',
        'ease-in-out',
        'delay-125',
        'overflow-auto',
        'scrollbar-none',
        'max-h-[calc(100vh_-_167px)]'
      )}
      onMouseLeave={onMouseLeaveMegaMenu}
      onMouseOver={onMouseOverMegaMenu}
    >
      <button
        className="btn--clear absolute right-0 top-0 flex h-9 w-9 items-center justify-center"
        onClick={onMegaMenuClose}
      >
        <Icon name="close" className="h-5 w-5" />
      </button>
      <div className="container flex h-full max-h-full flex-col gap-6">
        <div className="flex h-full max-h-full w-full flex-wrap gap-y-4">
          {link.links?.length > 0 &&
            link.links
              .sort((a, b) => (a.name > b.name ? 1 : -1))
              .map((subLink, idx) => (
                <div
                  key={link.url + subLink.url + 'mega-sub-' + idx}
                  className="flex w-1/4 flex-col gap-2 xl:w-1/6"
                >
                  <a
                    href={subLink.url}
                    className="underline-offset-5 text-md font-bold hover:underline"
                  >
                    {subLink.name ?? <>&nbsp;</>}
                  </a>
                  {subLink.links?.length > 0 &&
                    subLink.links
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .slice(0, 5)
                      .map((subSubLink) => (
                        <a
                          key={
                            subLink.url +
                            subSubLink.url +
                            subLink.name +
                            'mega-sub-2'
                          }
                          className="underline-offset-5 text-md lowercase first-letter:capitalize hover:underline"
                          href={subSubLink.url}
                        >
                          {subSubLink.name}
                        </a>
                      ))}
                  {subLink.links?.length > 5 && (
                    <a
                      href={subLink.url}
                      className="underline-offset-5 text-md hover:underline"
                    >
                      {translate('megamenu.show-more')}
                    </a>
                  )}
                </div>
              ))}
        </div>
        {blocks.length > 0 && <div ref={blockContainerRef}></div>}
      </div>
    </div>
  );
};

export default MegaMenu;
